module.exports = __webpack_public_path__ + "assets/img/btn-view-493b4092.png";